module.exports = __webpack_public_path__ + "img/home_1.29d7412d.svg";